<template>
  <div class="note-input content">
    <div :class="[note.content == null || note.content == '' ? 'data-table-list-comment nocomment' : 'data-table-list-comment']" @click="activeNote(note.content)" v-if="note_show != note.note_id">
      <pre style="margin:0">{{ note.content == null || note.content == "" ? "ノートを入力" : note.content }}</pre>
    </div>
    <div style="display:flex; align-items:center" v-if="note_show == note.note_id">
      <el-input
        v-model="note.content"
        :id="'note' + note.note_id"
        @change="comment_on ? '' : changeNote()"
        @blur="comment_on ? '' : changeNote()"
        :type="'textarea'"
        :autosize="{ minRows: 3, maxRows: 7 }"
      ></el-input>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const changeNoteAPI = root + "/api/note/change_note";
// const addNumAPI = root + "/api/list/add_num";
// const addPersonalizedNameAPI = root + "/api/list/add_personalized_name";

export default {
  name: "noteComment",
  props: ["note", "note_show", "id", "sns_type"],
  data() {
    return {
      comment_on: false,
      comment_before: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    permission() {
      return this.$store.state.permission.note.edit;
    },
  },
  methods: {
    activeNote(content) {
      if (this.permission) {
        this.$emit("update:note_show", this.note.note_id);
        this.comment_before = content;
        setTimeout(() => {
          document.getElementById("note" + this.note.note_id).focus();
        }, 50);
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    changeNote() {
      if (this.permission) {
        this.comment_on = true;
        this.$emit("update:note_show", -1);
        if (this.note.note_id == "new" && this.note.content == "") {
          this.$emit("clearNote");
        } else if (this.note.content != this.comment_before) {
          var params = new URLSearchParams();
          params.append("token", this.token);
          params.append("influencer", this.id);
          params.append("sns_type", this.sns_type);
          params.append("note_id", this.note.note_id);
          params.append("content", this.note.content);
          this.axios
            .post(changeNoteAPI, params)
            .then((response) => {
              if (this.note.note_id == "new") {
                this.note.note_id = response.data.note.note_id;
              }
            })
            .catch(() => {});
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "ノートを更新しました",
          });
        }
        setTimeout(() => {
          this.comment_on = false;
        }, 300);
      }
    },
  },
  watch: {},
};
</script>

<style></style>
